import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ConfirmDialogModule, ConfirmationService} from 'primeng/primeng';
import {Messages} from '../../../app.service';

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
  providers: [Messages, ConfirmationService]
})
export class HeaderComponent implements OnInit {

  constructor(private router: Router, private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    Messages.setService(this.confirmationService);
  }

  get blockedDocument(): boolean {
    return Messages.blockedDocument;
  }

  searchMobileActive = false;

  toggleSearchMobile(){
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/header.component.ts